import { useHasOnboarded } from '#app/hooks/useHasOnboarded.js';
import { type ReactNode } from 'react';

type ApprovalFilterProps = {
  readonly children: ReactNode;
  readonly hideForApprovedAndShowForUnapproved?: boolean;
};

// TODO: REMOVE/UPDATE after the users's approval status is available via the API
export const ApprovalFilter = ({
  children,
  hideForApprovedAndShowForUnapproved = false,
}: ApprovalFilterProps) => {
  const { hasOnboardedAtAll } = useHasOnboarded();
  const isUserApproved = hasOnboardedAtAll;

  if (
    (!isUserApproved && hideForApprovedAndShowForUnapproved) ||
    (isUserApproved && !hideForApprovedAndShowForUnapproved)
  ) {
    return <>{children}</>;
  }

  return null;
};
